/* eslint-disable camelcase */
import React from 'react';

import { useAppSelector } from '@/store/hooks';
import { ConfigHelper, ConfigKeys } from '@/utils/env';

const Pendo = (): React.JSX.Element => {
  const { userPassport } = useAppSelector((state) => state.auth);

  React.useEffect(() => {
    const apiKey = ConfigHelper.getConfig(ConfigKeys.PENDO_API_KEY);
    const sentryEnvironment = ConfigHelper.getConfig(ConfigKeys.SENTRY_ENVIRONMENT);

    const getUserPendoData = () => ({
      account: {
        customer_name: userPassport?.user?.customer_name,
        // Using sentry environment because it is the same for pendo as well
        // so we don't have to create a new env variable on manifest for pendo with the same value
        environment: sentryEnvironment,
        id: userPassport?.user?.customer_id,
      },
      visitor: {
        email: userPassport?.user?.email,
        emp_id: userPassport?.user?.emp_id,
        first_name: userPassport?.personnel?.first_name,
        id: userPassport?.user?.user_id,
        is_administrator: userPassport?.user?.is_admin,
        last_name: userPassport?.personnel?.last_name,
        user_name: userPassport?.user?.user_name,
      },
    });

    if (apiKey) {
      // Initialize pendo object on window.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).pendo = {
        _q: [['initialize', getUserPendoData()]],
      };

      // Load pendo.js
      const script = document.createElement('script');
      // eslint-disable-next-line no-magic-numbers
      const body = document.getElementsByTagName('body')[0];

      script.src = `https://content.analytics.lightning-bolt.com/agent/static/${apiKey}/pendo.js`;
      script.async = true;
      body.appendChild(script);
    }
  }, [userPassport]);

  return <></>;
};

export default Pendo;
